import {ReactInstance} from 'virtual-tour-viewer/src/modules/React360Proxy';
import CrosshairRaycaster from '../Raycasters/CrosshairRaycaster';
import {MouseRaycaster} from 'virtual-tour-viewer/src/modules/React360Proxy';
import {TouchRaycaster} from 'virtual-tour-viewer/src/modules/React360Proxy';

export default class RaycasterDirector {
    _reactInstance: ReactInstance;
    _mouseRaycaster: MouseRaycaster;
    _touchRaycaster: TouchRaycaster;
    _crosshairRaycaster: CrosshairRaycaster;

    constructor(reactInstance, fov) {
        this._reactInstance = reactInstance;
        this._reactInstance.controls.clearRaycasters();
        this._mouseRaycaster = new MouseRaycaster(this._reactInstance._eventLayer, fov);
        this._touchRaycaster = new TouchRaycaster(this._reactInstance._eventLayer, fov);
        this._crosshairRaycaster = new CrosshairRaycaster({
            frame: reactInstance._eventLayer,
        });
        this.usePointer();

        this._reactInstance.controls.addRaycaster(this._mouseRaycaster);
        this._reactInstance.controls.addRaycaster(this._touchRaycaster);
        this._reactInstance.controls.addRaycaster(this._crosshairRaycaster);
    }

    useCrosshair() {
        this._reactInstance.compositor.setCursorVisibility('visible');
        this._mouseRaycaster.disable();
        this._touchRaycaster.disable();
        this._crosshairRaycaster.enable();
    }

    usePointer() {
        this._reactInstance.compositor.setCursorVisibility('hidden');
        this._crosshairRaycaster.disable();
        this._mouseRaycaster.enable();
        this._touchRaycaster.enable();
    }
}
